/**
 * @file        src/pages/platform/Field.jsx
 * @description The labelled form field used across the platform (super admin)
 *              pages — label + required mark + hint/error line. Extracted from
 *              AddTenant.jsx when its onboarding panels were split into the
 *              Tenant Management section pages, so all five files share one
 *              copy instead of five.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (extracted from AddTenant.jsx).
 */
export default function Field({ label, required, err, hint, full, children }) {
  return (
    <div className={`field${full ? ' full' : ''}`}>
      <label>{label} {required ? <span className="req">*</span> : null}</label>
      {children}
      {hint && !err ? <div className="field-hint muted">{hint}</div> : null}
      {err ? <div className="field-error">{err}</div> : null}
    </div>
  );
}
